import { SelectElementMapper } from '../../_services/types/commons.type';
import { SharedFunnelDatalayerEvent } from '../../_services/types/datalayer.types';
import {
  BusinessCompanyRcClaimType,
  getBusinessCompanyRcClaimTypeLabel,
} from '../../enums/claim/business/business-company-rc-claim-type.enum';
import {
  getPreferredContactMethodLabel,
  PreferredContactMethod,
} from '../../enums/preferred-contact-method.enum';

export const BUSINESS_COMPANY_RC_BASE_URL = 'rc-entreprise';

export const BUSINESS_COMPANY_RC_FUNNEL_EVENT_BASE: SharedFunnelDatalayerEvent = {
  product_category: 'RC_ENTREPRISE',
  product_name: 'Claim',
  funnel_complete: false,
  get event() {
    return `${this.product_name}_${this.product_category}`;
  },
};

export const BUSINESS_COMPANY_RC_STEPS = {
  INCIDENT_DETAILS: {
    url: 'details-incident',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_COMPANY_RC_FUNNEL_EVENT_BASE,
      funnel_stage: 4,
      stage_name: 'Details incident',
    },
  },
  CLAIM_TYPE: {
    url: 'type-sinistre',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_COMPANY_RC_FUNNEL_EVENT_BASE,
      funnel_stage: 5,
      stage_name: 'Type sinistre',
    },
  },
  DOCUMENTS: {
    url: 'documents',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_COMPANY_RC_FUNNEL_EVENT_BASE,
      funnel_stage: 6,
      stage_name: 'Documents',
    },
  },
  VALIDATION: {
    url: 'validation',
    step: [4, 1],
    datalayerEvent: {
      ...BUSINESS_COMPANY_RC_FUNNEL_EVENT_BASE,
      funnel_stage: 7,
      stage_name: 'Validation',
    },
  },
} as const;

export const BUSINESS_COMPANY_RC_CLAIM_TYPE_OPTIONS: SelectElementMapper<BusinessCompanyRcClaimType> =
  {
    [BusinessCompanyRcClaimType.BODILY_INJURY]: {
      value: BusinessCompanyRcClaimType.BODILY_INJURY,
      label: getBusinessCompanyRcClaimTypeLabel(BusinessCompanyRcClaimType.BODILY_INJURY),
    },
    [BusinessCompanyRcClaimType.VEHICLE]: {
      value: BusinessCompanyRcClaimType.VEHICLE,
      label: getBusinessCompanyRcClaimTypeLabel(BusinessCompanyRcClaimType.VEHICLE),
    },
    [BusinessCompanyRcClaimType.MATERIAL]: {
      value: BusinessCompanyRcClaimType.MATERIAL,
      label: getBusinessCompanyRcClaimTypeLabel(BusinessCompanyRcClaimType.MATERIAL),
    },
    [BusinessCompanyRcClaimType.OTHER]: {
      value: BusinessCompanyRcClaimType.OTHER,
      label: getBusinessCompanyRcClaimTypeLabel(BusinessCompanyRcClaimType.OTHER),
    },
  };

export const BUSINESS_COMPANY_RC_CONTACT_METHOD_OPTIONS: SelectElementMapper<PreferredContactMethod> =
  {
    [PreferredContactMethod.EMAIL]: {
      value: PreferredContactMethod.EMAIL,
      label: getPreferredContactMethodLabel(PreferredContactMethod.EMAIL),
    },
    [PreferredContactMethod.PHONE]: {
      value: PreferredContactMethod.PHONE,
      label: getPreferredContactMethodLabel(PreferredContactMethod.PHONE),
    },
  };
